<template>
  <a :href="this.notification.data.sport_event_url" class="notification-item-wrap notification-item-wrap_time">
    <div v-if="!!this.notification.sport_event_name" class="event-name">
      <a :href="this.notification.data.sport_event_url">
        {{ this.notification.sport_event_name }}
      </a>
    </div>

    <div class="notification-item-message">
      <span>
        {{ I18n.t("sport_events.notifications.sport_event_time_changed", { old_time: this.notification.data.old_time, new_time: this.notification.data.new_time }) }}
      </span>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      notification: Object,
    },
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
</style>
